<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 8346 8346"
 xmlns:xlink="http://www.w3.org/1999/xlink">
 <g id="Vrstva_x0020_1">
  <g id="_527958384">
   <path class="fil0" d="M6474 3380l-554 0 0 -991c0,-1339 -1016,-2389 -2346,-2389 -1308,0 -2347,1110 -2347,2475l0 905 -617 0c-336,0 -610,274 -610,610l0 3746c0,335 274,610 610,610l5864 0c336,0 610,-275 610,-610l0 -3746c0,-336 -274,-610 -610,-610zm-2684 3426l0 0c0,101 -82,183 -183,183 -101,0 -183,-82 -183,-183l0 -1708c0,-101 82,-183 183,-183 101,0 183,82 183,183l0 1708zm1357 -3426l0 0 -3147 0 0 -905c0,-1046 585,-1689 1574,-1689 1022,0 1573,571 1573,1603l0 991z"/>
  </g>
 </g>
</svg>
</template>

<script>
export default {
  name: 'Security',
};
</script>

<style scoped>
.fil0 {fill:#56D6D1;fill-rule:nonzero}
</style>
